(() => {
  'use strict';
  let controller;
  let timer;

  const renderResults = async (input) => {
    const results = input.closest('dialog, .main-search')?.querySelector('[data-predictive-search-results]') || document.querySelector('[data-predictive-search-results]');
    const query = input.value.trim();
    if (!results || !window.theme.predictiveSearch || query.length < 2) {
      if (results) results.innerHTML = '';
      return;
    }
    controller?.abort();
    controller = new AbortController();
    results.setAttribute('aria-busy', 'true');
    try {
      const url = `${window.theme.rootUrl}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search`;
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Predictive search failed.');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const predictive = documentFragment.querySelector('.predictive-search');
      results.innerHTML = predictive ? predictive.outerHTML : '<p>No results found.</p>';
    } catch (error) {
      if (error.name !== 'AbortError') results.innerHTML = '<p>Search suggestions are temporarily unavailable.</p>';
    } finally {
      results.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-predictive-search-input]');
    if (!input) return;
    clearTimeout(timer);
    timer = setTimeout(() => renderResults(input), 220);
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-predictive-search-input]');
    if (!input || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    const links = [...input.closest('dialog').querySelectorAll('[data-predictive-search-results] a')];
    if (!links.length) return;
    event.preventDefault();
    (event.key === 'ArrowDown' ? links[0] : links[links.length - 1]).focus();
  });
})();
